import * as React from "react";

export const LazyParticles = React.lazy(
  () => import("./Particles" /* webpackChunkName: "particles" */),
);
